﻿export function VolumeDto() {
	this.Name = '';
	this.Width = 0;
	this.Height = 0;
	this.Length = 0;
	this.IsNegative = false;
}